import cn from "classnames";

import styles from "./ArticleSkeleton.module.scss";
import { RectangleSkeleton } from "../RectangleSkeleton/RectangleSkeleton";

const ArticleSkeleton = ({
  modal = false,
  hasAdFreeOffer = false,
}: {
  modal?: boolean;
  hasAdFreeOffer?: boolean;
}) => {
  return (
    <div className={cn([styles.container, modal && styles.modal])}>
      <div
        className={cn([styles.articleSkeletonContainer, modal && styles.modal])}
      >
        <RectangleSkeleton
          height="auto"
          width="100%"
          className={cn([
            styles.imageSkeleton,
            modal && styles.modalImageSkeleton,
          ])}
        />
        <div className={styles.articleTextSkeletons}>
          <RectangleSkeleton height="16px" width="40%" />
          <RectangleSkeleton height="60px" width="90%" />
          <RectangleSkeleton height="12px" width="25%" />
          <RectangleSkeleton height="12px" width="35%" />
          <RectangleSkeleton height="120px" width="100%" />
        </div>
      </div>
      <RectangleSkeleton
        height="600px"
        width="250px"
        desktopOnly
        className={cn([styles.sideAd, modal && styles.hidden])}
      />
    </div>
  );
};

export { ArticleSkeleton };
